/**
 * Created by Ram on 15/09/2016.
 */

import React, { Component }      from 'react';
import CustomerDashboard         from '../presentation/customer-dashboard';
import { CustomerAccountContext } from '../contexts/customer-account-context'

export default class AllCustomersInfoWidget extends Component {
    constructor(props) {
        super(props);
        this.state = {
            account: null
        }
    }

    componentWillMount() {
        this.refreshCustomer();
    }

    refreshCustomer = account => {
        if( account ) {
            this.setState({ account });
        }

        let params = 'id='+this.props.id;

        window.fetch("/service/account?"+params, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('idToken')}`
            },
            credentials: 'same-origin'
        }).then(response => {
            if( response.status != 200 ) {
                response.json().then(json => {
                    this.handleError(json, this);
                    return;
                });
            } else {
                response.json().then(json => {
                    this.loadAccount(json);
                });
            }
        });
    };

    loadAccount = account => {
        this.setState({ account });
    };

    render() {
        if (!this.state.account) return null;

        const accountProperties = {
            account: this.state.account,
            refreshCustomer: this.refreshCustomer
        }

        return (
            <CustomerAccountContext.Provider value={accountProperties}>
                <CustomerDashboard account={this.state.account} >{this.props.children}</CustomerDashboard>
            </CustomerAccountContext.Provider>
        )
    } // render
}; // AllCustomersInfoWidget
